<!--
 * @Descripttion: 
 * @version: 2.0.0
 * @Author: ck
 * @Date: 2019-09-11 10:36:24
 * @LastEditors: ck
 * @LastEditTime: 2019-09-23 16:54:09
 -->
<template>
  <div class="flex">
    <h1>404-没找到！</h1>
    <div
      class="but"
      @click="onClick"
    >返回</div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  metaInfo() {
    return {
      title: "404_传贝_让商业滋养幸福",
      meta: [
        {
          vmid: "description",
          name: "description",
          content: "404"
        },
        {
          vmid: "keywords",
          name: "keywords",
          content: "404"
        }
      ]
    };
  },
  methods: {
    onClick() {
      this.$router.go(-1);
    }
  },
  components: {}
};
</script>

<style lang='scss' scoped>
.flex {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  flex-direction: column;
}
.but {
  margin-top: 60px;
  cursor: pointer;
}
</style>
